'use client';
import React from 'react';
import { ProductCarousel as SharedProductCarousel } from '@launchstore/shared-puck';

export const ProductCarousel: any = SharedProductCarousel;
export default ProductCarousel;
